export const analyticsId = {
  AT_HOME_ABROAD_CARD_STEP_1_VIEW: 'AT_HOME_ABROAD_CARD_STEP_1_VIEW',
  AT_HOME_ABROAD_CARD_STEP_2_VIEW: 'AT_HOME_ABROAD_CARD_STEP_2_VIEW',
  AT_HOME_ABROAD_CARD_STEP_3_VIEW: 'AT_HOME_ABROAD_CARD_STEP_3_VIEW',
  AT_HOME_ABROAD_CARD_STEP_4_VIEW: 'AT_HOME_ABROAD_CARD_STEP_4_VIEW',
  AT_HOME_ABROAD_CARD_STEP_5_VIEW: 'AT_HOME_ABROAD_CARD_STEP_5_VIEW',
  AT_HOME_ABROAD_CARD_WIZARD_ERROR: 'AT_HOME_ABROAD_CARD_WIZARD_ERROR',
  AT_HOME_ABROAD_CARD_WIZARD_SUCCESS: 'AT_HOME_ABROAD_CARD_WIZARD_SUCCESS',
};

const commonFields = productName => ({
  sectionFamily: 'banking',
  sectionCategory: 'products',
  sectionName: 'cards',
  serviceType: 'productContracting',
  interactionType: 'funnel',
  processType: 'contractingCard',
  detalleProceso: productName,
  productName,
});

export const catalogue = {
  [analyticsId.AT_HOME_ABROAD_CARD_STEP_1_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_precontractual',
    pageName: '/contractingCard/step1/precontractual',
    processStep: 'step1',
    processDetail: 'precontractual',
  }),
  [analyticsId.AT_HOME_ABROAD_CARD_STEP_2_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_card_NGO_selection',
    pageName: '/contractingCard/step2/cardNGOSelection',
    processStep: 'step2',
    processDetail: 'cardNGOSelection',
  }),
  [analyticsId.AT_HOME_ABROAD_CARD_STEP_3_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_configuration',
    pageName: '/contractingCard/step3/configuration',
    processStep: 'step3',
    processDetail: 'configuration',
  }),
  [analyticsId.AT_HOME_ABROAD_CARD_STEP_4_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_shipment',
    pageName: '/contractingCard/step4/shipment',
    processStep: 'step4',
    processDetail: 'shipment',
  }),
  [analyticsId.AT_HOME_ABROAD_CARD_STEP_5_VIEW]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_confirmation',
    pageName: '/contractingCard/step5/confirmation',
    processStep: 'step5',
    processDetail: 'confirmation',
  }),
  [analyticsId.AT_HOME_ABROAD_CARD_WIZARD_ERROR]: ({ productName, errorMessage }) => ({
    ...commonFields(productName),
    event_name: 'step_error',
    pageName: '/contractingCard/error',
    processStep: 'error',
    errorCategory: 'requestError',
    errorDescription: errorMessage,
  }),
  [analyticsId.AT_HOME_ABROAD_CARD_WIZARD_SUCCESS]: ({ productName }) => ({
    ...commonFields(productName),
    event_name: 'step_success',
    pageName: '/contractingCard/success',
    processStep: 'success',
  }),
};
